// Minimal Zustand store: useCurrentLeaseStore.js (only checked fields, corrected)
import create from "zustand";
import { convertToDollar } from "../features/deal/helperFunctions/SaleFunctions";

const moneyFields = new Set([
	"approvedOptionsPrice",
	"approvedOptionsCost",
	"paidByCreditCard",
	"paidByCash",
	"paidByNonCash",
	"totalLease",
	"totalTax",
	"totalBase",
	"totalRent",
	"basePayment",
	"bankFee",
	"capCost",
	"capReduction",
	"dealerPrep",
	"depreciation",
	"disposition",
	"docfee",
	"downTax",
	"driveOff",
	"gapWaiver",
	"interest",
	"lsRebate",
	"mileageCharge",
	"monthlyDepreciation",
	"monthlyInterest",
	"monthlyTax",
	"msrp",
	"netCap",
	"otherFee",
	"payment",
	"perMileCharge",
	"price",
	"residualValue",
	"securityDeposit",
	"totTax",
	"warranty",
	"refundableReserve",
	"terminationFee",
	"dispostionFee",
	"adjustment",
	"proRataRent",
	"proRataSalesTax",
	"grossCapCost",
	"useTax",
	"additionalFee",
	"tradeAmtInDriveOff",
	"manualTaxAmount",
	"taxAmtInLease",
	"taxAmtInDriveOff",
	"down",
	"ppsa",
	"fuel",
	"gpsService",
	"walkaway",
	"omvic",
	"markup",
]);

const initialLeaseState = {
	id: null,
	recNum: null,
	rentChargeFactor: 0.0,
	msdOption: 0.0,
	securityDepositOption: 0.0,
	acquisitionFeeOption: 0,
	prepayOption: 0.0,
	dealerparticipationRentCharge: 0.0,
	standardResidualValue: 0.0,
	lowMileageOption: 0.0,
	approvedOptionsPrice: 0.0,
	approvedOptionsCost: 0.0,
	paidByCreditCard: 0.0,
	prePaymentOption: 0.0,
	dealerParticipationRentFactor: 0.0,
	additionalTax: 0.0,
	allowableMilesPerYear: 0,
	bankFee: 0.0,
	basePayment: 0.0,
	capCost: 0.0,
	capFLAG: "",
	daysToPay: 0,
	dealerPrep: 0.0,
	deliveryDate: "",
	depreciation: 0.0,
	disposition: 0.0,
	docfee: 0.0,
	downTax: 0.0,
	driveOff: 0.0,
	excessMilesPerYear: 0,
	firstPmtDate: "",
	gapWaiver: 0.0,
	interest: 0.0,
	leaseDate: "",
	leaseType: 0,
	lsNextDueDate: "",
	lsRebate: 0.0,
	mileageCharge: 0.0,
	milesPerYear: 0,
	miscFee: 0.0,
	moneyFactor: 0.0,
	monthlyDepreciation: 0.0,
	monthlyInterest: 0.0,
	monthlyTax: 0.0,
	msrp: 0.0,
	netCap: 0.0,
	otherFee: 0.0,
	payment: 0.0,
	perMileCharge: 0.0,
	price: 0.0,
	residualFactor: 0.0,
	residualValue: 0.0,
	markup: 0.0,
	securityDeposit: 0.0,
	term: 0,
	totExcessMiles: 0,
	totTax: 0.0,
	warranty: 0.0,
	apr: 0.0,
	refundableReserve: 0.0,
	paidByCash: 0.0,
	paidByNonCash: 0.0,
	totalLease: 0.0,
	totalTax: 0.0,
	totalBase: 0.0,
	totalRent: 0.0,
	terminationFee: 0.0,
	lateFeeDescrip: "",
	dispostionFee: 0.0,
	adjustment: 0.0,
	proRataRent: 0.0,
	proRataSalesTax: 0.0,
	grossCapCost: 0.0,
	capFirstPmt: false,
	leasePeriod: 0,
	useTax: 0.0,
	additionalFee: 0.0,
	tradeAmtInDriveOff: 0.0,
	manualTaxAmount: 0.0,
	taxAmtInLease: 0.0,
	taxAmtInDriveOff: 0.0,
	down: 0.0,
	ppsa: 0.0,
	fuel: 0.0,
	gpsService: 0.0,
	walkaway: 0.0,
	omvic: 0.0,

	capTaxOnReduction: false,
	capDispositionFee: false,
	capInsurance: false,
	cap1stPmt: false,
	capBankFee: false,
	capDMVFee: false,
	capDocFee: false,
	capGAPWaiver: false,
	capMiscFee: false,
	capOtherfee: false,
	capReduction: 0.0,
	capSalesTax: false,
	capWarranty: false,
	capSmogFees: false,
	lastEditedRate: "APR",

	dealerID: "",
	locationID: "",
};

const useCurrentLeaseStore = create((set) => ({
	...initialLeaseState,

	editField: (key, val) => set(() => ({ [key]: val })),

	setLeaseFields: (data) => {
		const formatted = Object.entries(data).reduce((acc, [key, val]) => {
			acc[key] =
				moneyFields.has(key) && typeof val === "number"
					? convertToDollar(val)
					: val;
			return acc;
		}, {});
		set(() => ({ ...formatted }));
	},

	resetLease: () => {
		set(() => ({ ...initialLeaseState }));
	},
}));

export default useCurrentLeaseStore;
